import { render, staticRenderFns } from "./picZoomProduct.vue?vue&type=template&id=00068b42&scoped=true&"
import script from "./picZoomProduct.vue?vue&type=script&lang=js&"
export * from "./picZoomProduct.vue?vue&type=script&lang=js&"
import style0 from "./picZoomProduct.vue?vue&type=style&index=0&id=00068b42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00068b42",
  null
  
)

export default component.exports